@if (messages.length) {
<div class="maintenance-scroller">
  <div class="ticker-wrap">
    <div class="ticker">
      <div class="ticker__item head">{{ message_head }}</div>
      @for (msg of messages; track msg) {
      <div class="ticker__item">{{ msg }}</div>
      }
    </div>
  </div>
</div>
}
